// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://iygygemmljgtakukonhk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml5Z3lnZW1tbGpndGFrdWtvbmhrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk2MzEyMDUsImV4cCI6MjA4NTIwNzIwNX0.ZQfj_9eBbthodiOWTVy7hl4gH6MzkNkTTj7ettt1AwA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});